"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSubjectSmsHistoryDownloadUrlResponse = exports.StudySubjectSmsExportFormat = exports.GetShortenUrlResponse = exports.GetEconsentUrlResponse = exports.GetStudySubjectSmsHistoryResponse = exports.SendEcoaAuthenticateSmsResponse = exports.SendEcoaAccessSmsResponse = exports.SubjectSmsType = exports.SubjectSmsHistoryStatus = void 0;
var SubjectSmsHistoryStatus;
(function (SubjectSmsHistoryStatus) {
    SubjectSmsHistoryStatus["Wait"] = "WAIT";
    SubjectSmsHistoryStatus["Processing"] = "PROCESSING";
    SubjectSmsHistoryStatus["Requested"] = "REQUESTED";
    SubjectSmsHistoryStatus["NotProcessed"] = "NOT_PROCESSED";
    SubjectSmsHistoryStatus["Sent"] = "SENT";
    SubjectSmsHistoryStatus["Expired"] = "EXPIRED";
    SubjectSmsHistoryStatus["Failed"] = "FAILED";
})(SubjectSmsHistoryStatus = exports.SubjectSmsHistoryStatus || (exports.SubjectSmsHistoryStatus = {}));
var SubjectSmsType;
(function (SubjectSmsType) {
    SubjectSmsType["ecoaAccess"] = "ECOA_ACCESS";
    SubjectSmsType["ecoaAuthenticate"] = "ECOA_AUTHENTICATE";
    SubjectSmsType["eConsent"] = "ECONSENT";
    SubjectSmsType["trigger"] = "TRIGGER";
})(SubjectSmsType = exports.SubjectSmsType || (exports.SubjectSmsType = {}));
class SendEcoaAccessSmsResponse {
}
exports.SendEcoaAccessSmsResponse = SendEcoaAccessSmsResponse;
class SendEcoaAuthenticateSmsResponse {
}
exports.SendEcoaAuthenticateSmsResponse = SendEcoaAuthenticateSmsResponse;
class GetStudySubjectSmsHistoryResponse {
}
exports.GetStudySubjectSmsHistoryResponse = GetStudySubjectSmsHistoryResponse;
class GetEconsentUrlResponse {
}
exports.GetEconsentUrlResponse = GetEconsentUrlResponse;
class GetShortenUrlResponse {
}
exports.GetShortenUrlResponse = GetShortenUrlResponse;
var StudySubjectSmsExportFormat;
(function (StudySubjectSmsExportFormat) {
    StudySubjectSmsExportFormat["Excel"] = "XLS";
    StudySubjectSmsExportFormat["CSV"] = "CSV";
})(StudySubjectSmsExportFormat = exports.StudySubjectSmsExportFormat || (exports.StudySubjectSmsExportFormat = {}));
class CreateSubjectSmsHistoryDownloadUrlResponse {
}
exports.CreateSubjectSmsHistoryDownloadUrlResponse = CreateSubjectSmsHistoryDownloadUrlResponse;
//# sourceMappingURL=subjectSms.js.map